module.exports = __webpack_public_path__ + "img/bockel-shooting-schlepper.d3634273.webp";